module.exports = __webpack_public_path__ + "ce811ec36b78394365c515a3e50a75c0.svg";